import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePricing } from '../hooks/usePricing';
import TopBar from '../components/TopBar';
import BottomNav from '../components/BottomNav';
import ProListingForm from '../components/ProListingForm';

/**
 * "List a Service" page (create mode). Flag-gated: renders the same coming-soon shell as
 * Services.js when pricing.services_enabled is false. On success, published listings go to
 * their public detail page; drafts go back to the dashboard.
 */
const CreateServiceListing = ({ profile, setProfile }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pricing, loading: pricingLoading } = usePricing();
  const servicesEnabled = Boolean(pricing?.services_enabled);

  const handleSuccess = ({ listing, published }) => {
    if (published && listing?.slug) {
      navigate(`/services/listings/${listing.slug}`);
    } else {
      navigate('/dashboard');
    }
  };

  if (!pricingLoading && !servicesEnabled) {
    return (
      <div className="min-h-screen-safe pb-nav md:pb-0">
        <TopBar profile={profile} setProfile={setProfile} />
        <div className="max-w-2xl mx-auto px-4 py-24 text-center">
          <h1 className="text-2xl sm:text-3xl font-bold mb-3">{t('services.comingSoonTitle')}</h1>
          <p className="text-muted-foreground">{t('services.comingSoonBody')}</p>
        </div>
        <BottomNav profile={profile} />
      </div>
    );
  }

  return (
    <div className="min-h-screen-safe pb-nav md:pb-0">
      <TopBar profile={profile} setProfile={setProfile} />
      <div className="max-w-2xl mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold">{t('services.createTitle')}</h1>
          <p className="text-muted-foreground">{t('services.createSubtitle')}</p>
        </div>
        <ProListingForm mode="create" onSuccess={handleSuccess} />
      </div>
      <BottomNav profile={profile} />
    </div>
  );
};

export default CreateServiceListing;
